import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import OneSignal from '@onesignal/capacitor-plugin';

// ─── OneSignal Push Notifications ───────────────────────────────────────────
// Replace 'YOUR_ONESIGNAL_APP_ID' with the App ID from your OneSignal dashboard
// Sign up free at: https://onesignal.com
const ONESIGNAL_APP_ID = 'YOUR_ONESIGNAL_APP_ID';

async function initOneSignal() {
  try {
    await OneSignal.initialize(ONESIGNAL_APP_ID);

    // Ask the user for permission to send notifications
    const { value: accepted } = await OneSignal.requestPermission();
    console.log('Push notification permission:', accepted ? 'granted' : 'denied');
  } catch (err) {
    console.warn('OneSignal init skipped (running in browser):', err.message);
  }
}

initOneSignal();
// ────────────────────────────────────────────────────────────────────────────

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
